import React,{ Component } from "react";
import {connect} from "react-redux";
import { Row, Col, Table, Card, CardBody, CardHeader, Button} from "reactstrap";
import Proptypes from "prop-types";
import ServiceBotSubscription from "../../../components/ServiceBot/Subscription/Subscription.js";
import ServiceBotSignup from "../../../components/ServiceBot/Signup/Signup.js";
import {getUser, getAllProducts} from "../../../actions/actionUser";
import LoadingSpinner from "../../../components/LoadingSpinner";
import { getNewToken } from "../../../actions/actionLogin";


class UserSubscription extends Component{
    constructor(props){
        super(props);
        this.state = {};
        this.handleResponse = this.handleResponse.bind(this);
        this.refreshToken = this.refreshToken.bind(this)
    }

    componentDidMount(){
        this.props.getUser().then((res) => {
            this.setState({user: res.response.user});
        });
        this.props.getAllProducts().then((res) => {
            if (res && res.response && res.response.length > 0){
                this.setState({has_products:true});
            }
        });
    }



    refreshToken(){
       const userInfo = JSON.parse(window.localStorage.getItem("user_info"));
       const payload_data = {
           token: userInfo.token,
           username: userInfo.username,
       };
       this.props.getNewToken(payload_data).then((res) => {
            window.location.href = "/"
        });

    }
    handleResponse(payload){
       if (payload.event && payload.event === "create_subscription"){
           setTimeout(() => {
            this.refreshToken();
          }, 3000);
       }
    }

    render(){
        if (this.props.getUsersLoading){
            return (<div> <LoadingSpinner /></div>);
        }

        const {user} = this.state;
        const {subSummary, subInfoLoading} = this.props

        return (
            <div className="profile-page">
                <Row>
                    <Col sm={{ size: 8, order: 3, offset: 2 }}>
                        { user && !user.program_id && this.state.has_products ?
                         <Card>
                            <CardHeader><strong>Subscription Details</strong></CardHeader>
                            <CardBody className="user-setting">
                                {
                                    !subInfoLoading && subSummary ?
                                        <React.Fragment>
                                          <ServiceBotSubscription
                                            email={user.username}
                                            hash={user.hash}
                                          />
                                        </React.Fragment>
                                    :
                                        <React.Fragment>
                                            <ServiceBotSignup
                                                email={user.username}
                                                hash={user.hash}
                                                handleResponse={this.handleResponse}
                                            />
                                        </React.Fragment>
                                    }
                            </CardBody>
                        </Card>

                            :
                            ""
                        }
                    </Col>

                </Row>
            </div>
        );}
}

UserSubscription.propTypes = {
};

export default connect(state =>
    ({
        user: state.user.user || [],
        createSub: state.user.createSub,
        subSummary: state.user.subSummary,
        subInfoLoading: state.user.subInfoLoading,
        getUsersLoading: state.user.getUsersLoading || null,
    }),
dispatch =>
    ({
        getUser: () => dispatch(getUser()),
        getAllProducts: () => dispatch(getAllProducts()),
        getNewToken: (payload_data) => dispatch(getNewToken(payload_data)),
    }))(UserSubscription);
